import React, { useState } from "react";
import {
  Container,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
  ProgressBar
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function FrontendCompress() {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [compressProgress, setCompressProgress] = useState(0);
  const [uploadProgress, setUploadProgress] = useState(0);
  const navigate = useNavigate();

  // 🔹 Frontend compression (UNCHANGED LOGIC)
  const clientCompress = async (file) => {
    const video = document.createElement("video");
    video.src = URL.createObjectURL(file);
    video.muted = false;
    video.playsInline = true;

    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const source = audioCtx.createMediaElementSource(video);
    const dest = audioCtx.createMediaStreamDestination();
    source.connect(dest);

    await video.play();

    // ⏳ Fake-but-honest compression progress
    let fakeProgress = 0;
    const interval = setInterval(() => {
      fakeProgress += 5;
      setCompressProgress(Math.min(fakeProgress, 95));
    }, 500);

    const targetWidth = 1280;
    const scale = targetWidth / video.videoWidth;
    const targetHeight = Math.round(video.videoHeight * scale);

    const canvas = document.createElement("canvas");
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");

    const canvasStream = canvas.captureStream(30);
    const audioTrack = dest.stream.getAudioTracks()[0];

    const combinedStream = new MediaStream([
      ...canvasStream.getVideoTracks(),
      ...(audioTrack ? [audioTrack] : [])
    ]);

    const recorder = new MediaRecorder(combinedStream, {
      mimeType: "video/webm;codecs=vp8,opus",
      videoBitsPerSecond: 800_000,
    });

    const chunks = [];
    recorder.ondataavailable = e => e.data.size && chunks.push(e.data);
    recorder.start();

    const drawFrame = () => {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      if (!video.paused && !video.ended) requestAnimationFrame(drawFrame);
    };
    drawFrame();

    await new Promise(r => (video.onended = r));
    recorder.stop();
    await new Promise(r => (recorder.onstop = r));

    clearInterval(interval);
    setCompressProgress(100);
    audioCtx.close();

    return new Blob(chunks, { type: "video/webm" });
  };

  // 🔹 Upload with REAL progress
  const uploadWithProgress = (file) =>
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      const formData = new FormData();
      formData.append("video", file);

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const percent = Math.round((e.loaded / e.total) * 100);
          setUploadProgress(percent);
        }
      };

      xhr.onload = () => {
        xhr.status === 200 || xhr.status === 201
          ? resolve()
          : reject();
      };

      xhr.onerror = reject;

      xhr.open(
        "POST",
        "https://extapi.jacuji.com/api/videos/upload-direct"
      );
      xhr.send(formData);
    });

  // 🔹 Main handler
  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    setStatus("Compressing video...");
    setCompressProgress(0);
    setUploadProgress(0);

    try {
      const compressed = await clientCompress(file);

      setStatus("Uploading video...");
      await uploadWithProgress(compressed);

      setStatus("✅ Upload successful! Redirecting...");
      setTimeout(() => navigate("/compressed-list"), 2000);
    } catch (err) {
      console.error(err);
      setStatus("❌ Something went wrong");
    }

    setLoading(false);
  };

  return (
    <Container className="mt-5">
      <Card className="shadow">
        <Card.Body>
          <Card.Title>Frontend Video Compression</Card.Title>

          <Form.Group className="mb-3">
            <Form.Control type="file" accept="video/*" onChange={upload} />
          </Form.Group>

          {loading && (
            <>
              <div className="mb-2">Compression Progress</div>
              <ProgressBar
                animated
                now={compressProgress}
                label={`${compressProgress}%`}
                className="mb-3"
              />

              <div className="mb-2">Upload Progress</div>
              <ProgressBar
                striped
                variant="success"
                now={uploadProgress}
                label={`${uploadProgress}%`}
              />

              <Spinner animation="border" size="sm" className="mt-3" />
            </>
          )}

          {status && <Alert className="mt-3">{status}</Alert>}

          <Button disabled>Upload happens automatically</Button>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default FrontendCompress;
